<div class="title-container d-flex align-items-start ms-5 ms-sm-0 me-xl-0 px-0 ps-sm-3 pe-xl-3 pt-1 pb-1 pt-sm-3 pb-sm-3"
     [class.me-5]="isDetail()">
  <h2 class="title text-primary mb-0 flex-shrink-1">
    <ng-content select="[title]"></ng-content>
  </h2>
  <ng-content></ng-content>
  <div class="ms-auto flex-shrink-1 d-flex align-items-center">
    <ng-content select="[right]"></ng-content>
    <ng-content select="era-context-menu"></ng-content>
  </div>
</div>